import React from 'react';
import { Outlet } from 'react-router-dom';
import { YoneticiHeader } from './YoneticiHeader';
import { SidebarFloating } from './SidebarFloating';
export function YoneticiLayout() {
  return <div className="flex flex-col min-h-screen bg-[#0D1117] text-gray-300" data-id="element-237">
      {/* Header - Full width at top */}
      <header className="w-full" data-id="element-238">
        <YoneticiHeader data-id="element-239" />
      </header>
      {/* Main content area - Sidebar and content side by side */}
      <main className="flex flex-row flex-1 px-4 md:px-6 pb-4 md:pb-6 gap-4 md:gap-6" data-id="element-240">
        {/* Sidebar */}
        <SidebarFloating data-id="element-241" />
        {/* Main content */}
        <div className="flex-1 overflow-auto" data-id="element-242">
          <Outlet data-id="element-243" />
        </div>
      </main>
    </div>;
}